<template>
  <CRow>
    <CCol col="12">
      <CCard>
        <CCardHeader class="d-flex justify-content-between align-items-center">
          <h5 class="mb-0">Resume Template Details</h5>
          <CButton color="primary" @click="goBack">Back to List</CButton>
        </CCardHeader>

        <CCardBody v-if="template">
          <!-- General Info -->
          <CCard class="mt-2 shadow-sm">
            <CCardHeader class="bg-info text-white">
              <h6 class="mb-0">General Information</h6>
            </CCardHeader>
            <CCardBody>
              <CRow>
                <CCol md="6">
                  <p><strong>Title:</strong> {{ template.title }}</p>
                  <p><strong>Type:</strong> {{ template.type }}</p>
                  <p><strong>Slug:</strong> {{ template.slug }}</p>
                  <p><strong>Created At:</strong> {{ formatDate(template.createdAt) }}</p>
                </CCol>
                <CCol md="6">
                  <p><strong>SKU Code (Android):</strong> {{ template.skuCodeAndroid }}</p>
                  <p><strong>SKU Code (IOS):</strong> {{ template.skuCodeIos }}</p>
                  <!-- <p><strong>Color:</strong> <span :style="{color: template.color}">{{ template.color }}</span></p> -->
                  <p><strong>Font:</strong> {{ template.fontStyle }} ({{ template.fontSize }})</p>
                  <p><strong>Status:</strong> <CBadge :color="template.isActive ? 'success' : 'secondary'">{{ template.isActive ? 'Active' : 'Inactive' }}</CBadge></p>
                </CCol>
                <CCol md="12">
                  <p><strong>Description:</strong> {{ template.description }}</p>
                  <!-- <p><strong>Template View:</strong> {{ template.templateView }}</p>
                  <p><strong>Image:</strong> <img :src="template.templateImage" alt="Template Image" style="max-width:150px;" /></p> -->
                </CCol>
              </CRow>
            </CCardBody>
          </CCard>

          <!-- Platforms -->
          <CCard class="mt-3 shadow-sm" v-if="template.platforms && template.platforms.length" v-for="platform in template.platforms" :key="platform.id">
            <CCardHeader class="bg-warning text-dark">
              <h6 class="mb-0 text-white">Platform: {{ platformLabel(platform.platform) }}</h6>
            </CCardHeader>
            <CCardBody>
              <CRow class="border-bottom pb-2 mb-2">
                <CCol
                  md="6"
                  v-for="price in platform.prices"
                  :key="price.id"
                  class="mb-3"
                >
                  <CCard class="shadow-sm">
                    <CCardBody>
                      <p><strong>Currency:</strong> {{ price.currency.currencyCode }} ({{ price.currency.symbol }})</p>
                      <p><strong>Price:</strong> {{ price.price }}</p>
                      <p><strong>Offer Price:</strong> {{ price.offerPrice }}</p>
                      <p><strong>Total Paid:</strong> {{ price.totalAmountPaidByMember }}</p>
                      <p><strong>Platform Fee:</strong> {{ price.platformFee }} ({{ price.platformFeePercentage }}%)</p>
                      <p><strong>GST on Plan:</strong> {{ price.gstOnPlan }}</p>
                      <p><strong>Base Plan Price:</strong> {{ price.basePlanPrice }}</p>
                      <p><strong>Amount to Resourceful:</strong> {{ price.amountToResourceful }}</p>
                    </CCardBody>
                  </CCard>
                </CCol>
              </CRow>
            </CCardBody>
          </CCard>
        </CCardBody>

        <CCardBody v-else>
          <CAlert color="info" show>Loading resume template details...</CAlert>
        </CCardBody>

        <CCardFooter>
          <CButton color="primary" @click="goBack">Back to List</CButton>
        </CCardFooter>
      </CCard>
    </CCol>
  </CRow>
</template>

<script>
import { resumeTemplatePlan } from '/src/store/url.js'
import { Mixin } from '/src/mixins/index.js'
import store from '@/store/store'

export default {
  name: 'ResumeTemplateDetails',
  mixins: [Mixin],
  data() {
    return {
      template: null,
      id: this.$route.params.id,
      module: resumeTemplatePlan
    }
  },
  mounted() {
    store.commit('showLoader', true)
    this.fetchDetails()
  },
  methods: {
    platformLabel(val) {
      const mapping = { 0: 'Web', 1: 'Android', 2: 'IOS' }
      return mapping[val] || val
    },
    async fetchDetails() {
      try {
        const response = await axios.get(this.viewUrlApi(this.module, this.id))
        this.template = response.data.data
      } catch (error) {
        console.error('Error:', error)
        this.template = null
      } finally {
        store.commit('showLoader', false)
      }
    },
    goBack() {
      this.$router.push({ name: 'Resume Template List' })
    },
    formatDate(date) {
      if (!date) return 'N/A'
      return new Date(date).toLocaleDateString('en-IN', {
        year: 'numeric',
        month: 'long',
        day: 'numeric'
      })
    }
  }
}
</script>

<style scoped>
p {
  margin-bottom: 0.5rem;
}
h6 {
  margin-bottom: 0;
}
.shadow-sm {
  box-shadow: 0px 4px 6px rgba(0, 0, 0, 0.1);
}
</style>
